
eval("define(\'text!app/templates/viewer/text-view.html\',[],function () { return \'<span class=\"tags-container\">\\n    <%- value %>\\n</span>\\n\\n\\n\\n\\n\\n\';});\n\n//# sourceURL=/text!app/templates/viewer/text-view.html");

